import React from 'react'
import Layout from '../Layout'
import styled from 'styled-components'

//sections

//components
import SEO from '../components/SEO'
import Header from '../components/Header'
import Paragraph from '../components/Paragraph'
import SectionSeparator from '../components/SectionSeparator'

//images
import BgImage from '../assets/images/intro-bg.png'
import BgTextured from '../assets/images/bg3.png'


const Wrapper = styled.section`
  position: relative;
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100vh;
  background: #171717;
  background: top left no-repeat;
  background-image: url(${({ background }) => (background) ? background : '' });
  background-size: cover;
  transition: all 0.3s ease;

  h2 {
    margin-top: 50px;
  }

  ${({ theme }) => theme.media.l} {
    flex-direction: row;
  }
`

const InnerWrapper = styled.div`
  width: 100%;
  max-width: 1280px;
  max-width: ${({ maxWidth }) => (maxWidth) ? maxWidth : '1080px' };
  margin: auto;
  padding: 80px 30px 100px;
  display: ${({ display }) => (display) ? display : '' };
`

const Content = styled.div`
  padding: 15px;
  width: ${({ width }) => (width) ? width : '100%' };
`

const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 100px 30px 100px;
  margin-left: auto;
  margin-right: auto;
  z-index: 2;
  position: relative;

  ${({ theme }) => theme.media.m} {
    padding: 140px 30px 100px;
  }

  ${({ theme }) => theme.media.l} {
    padding: 180px 50px 100px;
  }

  ${({ theme }) => theme.media.xl} {
    padding-top: 240px;
  }

  ${({ theme }) => theme.media.xxl} {
    padding-top: 360px;
  }
`

const BackgroundImage = styled.figure`
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: -15%;
  width: 115%;
  height: 100%;
  background: top left no-repeat;
  background-size: cover;
  z-index: 1;

  opacity: 1;

  background-image: url(${({ image }) => image});

  -webkit-animation-delay: ${({ delay }) => delay}s;
  
`

const UsEnjoy = styled.div`
  display: block;
  ${({ theme }) => theme.media.l} {
    display: flex;
  }
  div {
    padding: 5px;
  }
`

const CareersPage = () => {

  const images = [BgImage]

  let imagesCount = 1
  let duration = 10
  let transition = 2

  const t = imagesCount * (duration + transition)

  const p1 = Math.round(transition / t * 100)
  const p2 = Math.round((duration + transition) / t * 100)
  const p3 = Math.round(p2 * 1.6)

  let keyframesMove = `
    0% {opacity: 0;}
    ${p1}% {opacity: 0.5;}
    ${p2}% {opacity: 0.5;}
    ${p3}% {opacity: 0;}
    100% {opacity: 0;}
  `
  let keyframesHeroMove = `
    0% {
      transform: translate3d(0, 0, 0);
    }
    50% {
      transform: translate3d(10%, 0, 0);
    }
    100% {
      transform: translate3d(0, 0, 0);
    }
  `

  let keyframes = `
    @keyframes fade {
      ${keyframesMove}
    }
    @-webkit-keyframes fade {
      ${keyframesMove}
    }
    @keyframes heroMoveSlide {
      ${keyframesHeroMove}
    }
    @-webkit-keyframes heroMoveSlide {
      ${keyframesHeroMove}
    }
  `

  const keywords = [
    'F&B jobs', 
    'waitress job hk',
    'waitress jobs in hong kong',
    'restaurant jobs hk',
    'restaurant jobs in hong kong',
    'bartender jobs in hong kong',
    'bartender job hk'
  ];

  return (
    <Layout>
      <SEO 
        title="Restaurant Jobs in Hong Kong | F&B Career" 
        canonical="https://www.sandshospitality.com/careers/"
        description="Apply for an F&B job at S&S Hospitality to work alongside a host of world class chefs and bartenders in Hong Kong’s most distinguished restaurants."
        keywords={keywords}
      />
      <Wrapper>
        <Container>
            <Header align="left" paddingBottom="30px">F&B Jobs and Career</Header>
            <Paragraph white>
              Springboard your career by joining one of the most renowned F&B groups in Hong Kong. Apply for a restaurant job at S&S Hospitality and let your talent shine in front of an international audience.
            </Paragraph>
        </Container>
        {images.map((img, key) =>
          <BackgroundImage key={key}
            style={{
              backgroundImage: `url(${img})`,
              animationDelay: `${(duration + transition) * key}s`
            }}
            totalDuration={t}
          />
        )}
        <style>{keyframes}</style>
      </Wrapper>
      <Wrapper background={BgTextured}>
        <SectionSeparator />
        <InnerWrapper>
          <h2 style={{ textAlign: 'center', margin: '35px 0px', fontSize: '35px' }}>Our Team</h2>
          <Content width="100%">
            <Paragraph center>
            Hospitality is a team sport. Food, wine, service - teams that succeed have top talents in every department. From Michelin-starred chefs to world class bartenders, S&S Hospitality has gathered the best from across the world to provide the best F&B experience in Hong Kong. 
            </Paragraph>
            <Paragraph center>
            Waitresses, servers, bartenders, or chefs, whatever job it is, the best candidates in Hong Kong are found here on our team. Led by innovative geniuses in the likes of Michelin-starred Chef Enrico Bartolini, the people at our restaurants will enchant you, intrigue you, and inspire you. Here, every job in the restaurant is just as important as the other and every individual has their chance to shine.
            </Paragraph>
          </Content>
        </InnerWrapper>
        <SectionSeparator />
        <InnerWrapper>
          <Content width="100%">
            <h2 style={{ textAlign: 'center', margin: '35px 0px', fontSize: '35px' }}>Join Us</h2>
            <Paragraph center>
            Every department in our team, from chefs and bartenders to waitresses and hosts, demonstrate their great talent every evening and provide an extraordinary experience for our guests. If you have the ambition to work in the best restaurants in Hong Kong, this is where you belong.
            </Paragraph>
            <Paragraph center>
            You will become part of a cohesive team and share the stage with seasoned professionals that have years of experience working in high-end restaurant jobs in Hong Kong and abroad. Whether you are an experienced veteran or a young and ambitious graduate starting your F&B career, you will find opportunities here to learn and make fast progression like nowhere else.
            </Paragraph>
            <Paragraph center>
            We offer a competitive remuneration package and benefits that will be attractive to anyone looking for F&B jobs in Hong Kong. Apply for one of our positions now.
            </Paragraph>
          </Content>
        </InnerWrapper>
        <SectionSeparator />
        <InnerWrapper>
          <Content width="100%">
            <h2 style={{ textAlign: 'center', margin: '35px 0px', fontSize: '35px' }}>F&B Job Vacancies</h2>
            <UsEnjoy>
              <div>
                <h3>Culinary</h3>
                <Paragraph>
                  Join a team led by award-winning professionals with incredible resumes, including Michelin starred chefs and internationally recognised restauranteurs.
                </Paragraph>
              </div>
              <div>
                <h3>Service</h3>
                <Paragraph>
                  Share the front line with the best hosts and waitresses in Hong Kong and amaze our guests with an unforgettable experience.
                </Paragraph>
              </div>
              <div>
                <h3>Culinary</h3>
                <Paragraph>
                  Beverages are the difference between a good meal and a great one. Work alongside the best bartenders in Hong Kong and be the difference.
                </Paragraph>
              </div>
            </UsEnjoy>
          </Content>
        </InnerWrapper>
        <SectionSeparator />
        <InnerWrapper>
          <Content width="100%">
            <h2 style={{ textAlign: 'center', margin: '35px 0px', fontSize: '35px' }}>Contact Us</h2>
            <UsEnjoy>
              <div>
                <Paragraph white>
                  We are looking for the best talents in Hong Kong to fill our restaurant job positions. If you have any questions or enquiries, do not hesitate to contact our team via <a href="mailto:hr@sandshospitality.com" style={{ fontWeight: '700', opacity: 1}}>hr@sandshospitality.com</a> and we will get back to you as soon as possible.
                </Paragraph>
              </div>
            </UsEnjoy>
          </Content>
        </InnerWrapper>
      </Wrapper>

    </Layout>
  )
}

export default CareersPage
